import { BackButton } from 'atoms/BackButton';
import { Button } from 'atoms/Button';
import { InquirySchemaType } from 'commons/Inquiry';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';
import React, { useContext } from 'react';
import { AppContext } from 'templates/AppContextProvider';
import { AppFooter } from 'templates/AppFooter';
import { AppHeader } from 'templates/AppHeader';
import { Form } from 'templates/Form';
import { PageContent } from 'templates/PageContent';

const replaceNewLinesWithBreakTags = (str: string) => {
  return str.split('\n').map((line, index) => (
    <React.Fragment key={index}>
      {line}
      {index !== str.split('\n').length - 1 && <br />}
    </React.Fragment>
  ));
};

export function InquiryConfirmation({
  formData,
  onBack,
  onConfirm,
}: {
  formData: InquirySchemaType;
  onBack: () => void;
  onConfirm: () => void;
}) {
  const { t: tInquiry } = useTranslationWithLang('inquiry');
  const { currentLang } = useContext(AppContext);
  return (
    <>
      <AppHeader />
      <div role="heading" aria-level={1} className="sr-only">
        {tInquiry('TU012_013')}
      </div>
      <PageContent>
        <Form title={tInquiry('TU012_013')}>
          <div aria-live="polite">
            <h1 className="text-xl mb-4">{tInquiry('TU012_009')}</h1>
            <div>
              <div role="group" aria-labelledby="name-label">
                <p id="name-label" className="text-xl font-bold mb-4">
                  {tInquiry('TU012_002')}
                </p>
                <p className="text-lg mb-8">{`${formData?.lastName || ''} ${formData?.firstName || ''}`}</p>
              </div>
              {currentLang === 'ja' && (
                <div role="group" aria-labelledby="name-kana-label">
                  <p id="name-kana-label" className="text-xl font-bold mb-4">
                    {tInquiry('TU012_018')}
                  </p>
                  <p className="text-lg mb-8">{`${formData?.lastNameKana || ''} ${formData?.firstNameKana || ''}`}</p>
                </div>
              )}
              <div role="group" aria-labelledby="mail-label">
                <p id="mail-label" className="text-xl font-bold mb-4">
                  {tInquiry('TU012_005')}
                </p>
                <p className="text-lg mb-8">{formData?.mail || ''}</p>
              </div>
              <div role="group" aria-labelledby="phone-label">
                <p id="phone-label" className="text-xl font-bold mb-4">
                  {tInquiry('TU012_006')}
                </p>
                <p className="text-lg mb-8">{formData?.phoneNumber}</p>
              </div>
              <div role="group" aria-labelledby="inquiry-label">
                <p id="inquiry-label" className="text-xl font-bold mb-4">
                  {tInquiry('TU012_007')}
                </p>
                <p className="text-lg mb-8">
                  {formData?.inquiry && replaceNewLinesWithBreakTags(formData.inquiry)}
                </p>
              </div>
            </div>
          </div>
          <div className={'flex justify-center items-center'}>
            <BackButton
              className="mr-6 w-[9rem]"
              style={{ paddingTop: '0.9rem', paddingBottom: '0.9rem' }}
              onClick={() => onBack()}
            />
            <Button
              label={tInquiry('TU012_008')}
              type="button"
              className="w-[9rem]"
              onClick={onConfirm}
            />
          </div>
        </Form>
      </PageContent>
      <AppFooter />
    </>
  );
}
